import { Dimension } from "../models/Dimension";

export class UxUtils {
  static moveTo = (htmlDomId: string) => {
    const dom = document.getElementById(htmlDomId);
    if (dom) {
      dom.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  };

  static popupWindow = (url = "", title = "", w = 0, h = 0) => {
    const left = screen.width / 2 - w / 2;
    const top = screen.height / 2 - h / 2;
    return window.open(
      url,
      title,
      `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=true, resizable=true, width=${+w}, height=${+h}, top=${+top}, left=${+left}`
    );
  };

  static getDimension = (domRef: any): Dimension => {
    const { top, right, bottom, left, width, height, x, y } =
      domRef.getBoundingClientRect();
    return { top, right, bottom, left, width, height, x, y };
  };
}
